import { render, staticRenderFns } from "./TheModalFarmacia.vue?vue&type=template&id=522ba2e3&scoped=true&"
import script from "./TheModalFarmacia.vue?vue&type=script&lang=js&"
export * from "./TheModalFarmacia.vue?vue&type=script&lang=js&"
import style0 from "./TheModalFarmacia.vue?vue&type=style&index=0&id=522ba2e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ba2e3",
  null
  
)

export default component.exports